import { MutationTree } from 'vuex'
import { SettingsState } from '@/store/settings/types'
import { SETTINGS_BULK_SET_PREFERENCES, SETTINGS_SET_PREFERENCE } from '@/store/settings/constants'

const mutations: MutationTree<SettingsState> = {
    /**
     * Set all preferences
     */
    [SETTINGS_BULK_SET_PREFERENCES](state, preferences): void {
        state.preferences = preferences
    },

    /**
     * Set a single preference
     */
    [SETTINGS_SET_PREFERENCE](state, { type, key, value }): void {
        state.preferences[type][key] = value
    }
}

export default mutations
